import useApi from '../../api/backendApiContext';
import { useMutation } from '@tanstack/react-query';
import { useNotification } from '../../notification/notificationsContext';
import { FundingData } from '../types';
import { analyticsTrack } from '../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';

export const useRequestFundingMutation = (onSuccess: () => void) => {
  const { fundingApi } = useApi();
  const { notifyError } = useNotification();

  return useMutation(
    async (params: { partnerName: string; partnerCode: string; funding: FundingData }) =>
      fundingApi.requestIntroduction(params),
    {
      onSuccess: (_, variables) => {
        onSuccess();
        analyticsTrack(AnalyticsEvent.FUNDING_INTRODUCTION_REQUESTED, {
          code: variables.partnerCode,
        });
      },
      onError: () => {
        notifyError({
          notificationMsg: 'Something went wrong. Please try again later or contact support.',
          logMsg: 'Error requesting funding partner introduction',
        });
      },
    }
  );
};
